import { render } from "./GoBackButton.vue?vue&type=template&id=1f38e96c"
const script = {}

import exportComponent from "/var/www/eemas/aims2go/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__